import {EventData} from '@/types/event';

export const isEventPaidWithParticipants = (
  event: EventData,
  userId: string
): boolean => {
  return (
    event.isPaid &&
    (event.participants.length > 1 ||
      (event.participants.length === 1 &&
        !event.participants.some((p) => p._id === userId)))
  );
};
